// extracted by mini-css-extract-plugin
export default {"container":"audio-detail-toolbar_container__iT+iu","upload-container":"audio-detail-toolbar_upload-container__oibvm","size-container":"audio-detail-toolbar_size-container__WmjqB"};